import React from "react";
import { useEffect, useState } from "react";
import { useMap, GeoJSON } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";
import { closeTools } from "../../../features/tools/toolsSlice";
import classes from "./ToolsPanel.module.css"
import L from "leaflet";
import close from "../../../pic/close.png";
import styled from "styled-components";
import { setAnalyticsVisual } from "../../../features/layers/analyticsslice";
import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
import { VideoCall } from "@material-ui/icons";
import jwt from 'jsonwebtoken';

var axios = require("axios");

const Filter = () => {
  const [circle, setCircle] = useState( [{cl_name: 'select'}]);
  const [within, setWithin] = useState([]);
  const layers=useSelector(selectLayerDataSet);
  const [dropdowns, setDropdowns] = useState([]);
  const [options, setOptions] = useState([]);
  const [circleData, setCircleData] = useState( [{cl_name: 'select'}]);
  const [VillageData, setVillageData] = useState( [{villagenam: 'select'}]);
  const [circleHandle, setCircleHandle] = useState();
  const [VillageHandle, setvillageHandle] = useState();
  const [selectedValues, setSelectedValues] = useState({});
  const [database, setdatabase] = useState();
  const [maindata, setmaindata] = useState();
  const [showElements, setShowElements] = useState(false);
  const [url, seturl] = useState();
  const [selectedOption, setSelectedOption] = useState('');
  const [browser, setBrowser] = useState(null);
  const [ipAddress, setIPAddress] = useState('');
  const [userdata, setUserData] = useState();
  useEffect(() => {
    const getBrowserDetails = () => {
      const { userAgent, platform } = navigator;
      const browserName = detectBrowser(userAgent);
      const browserVersion = detectBrowserVersion(userAgent);
      const details = {
        userAgent,
        platform,
        browserName,
        browserVersion
      };

      setBrowser(details);
    };

    getBrowserDetails();
  }, []);
  const detectBrowser = (userAgent) => {
    const UAParser = require('ua-parser-js');
    const parser = new UAParser();
    const result = parser.setUA(userAgent).getBrowser();
    return result.name;
  };

  // Function to detect browser version
  const detectBrowserVersion = (userAgent) => {
    const UAParser = require('ua-parser-js');
    const parser = new UAParser();
    const result = parser.setUA(userAgent).getBrowser();
    return result.version;
  };
  useEffect(() => {
    const fetchIPAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIPAddress(data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };
    fetchIPAddress();
  }, []);
  
  const JWTDecoder = () => {
    const jwtToken = localStorage.getItem('token');
    try {
      const decodedToken = jwt.decode(jwtToken);
      setUserData(decodedToken); // Display the decoded token in the console
    } catch (error) {
      console.error('Error decoding JWT:', error);
    }
  };
  useEffect(() => {
    JWTDecoder()
  }, []);
  const userLogs=()=>{
    var fdata = new FormData();
    fdata.append("browser_used", browser['browserName']+', V '+browser['browserVersion']+ ', OS ' +browser['platform'])
    fdata.append("session_time", 0)
    fdata.append("ip", ipAddress)
    fdata.append("time", Date())
    fdata.append("print", 0)
    fdata.append("userid", userdata['username'])
    fdata.append("toolused", 'Filter')
    fdata.append("q_performed", 'on layer '+database)
    // axios({
    //   method: "post",
    //   url: 'http://112.133.197.42/API/user_q.php',
    //   data: fdata,
    //   headers: { "Content-Type": "multipart/form-data" },
    // })
    //   .then(function (response) {
    //     if(response.data){
    //       console.log(response.data)
    //     }
        
    //   })
    //   .catch(function (response) {
    // });
  }



  const handleRadioChange = (event) => {
    setShowElements(event.target.value === 'show');
  };
  const dispatch = useDispatch();
  let arrdata=[]
  const ChangeMap = () => {
    dispatch(
      closeTools({
        name: "Measure",
      })
    );
  };
  const handlerc = (event) => {
    const selectedValue = event.target.value;
    const selectedText = event.target.options[event.target.selectedIndex].text;
    setSelectedOption(selectedText);
    setdatabase(selectedValue)
    fetchData(selectedValue)

  };
  const handleWithin = (event) => {
    //console.log(event.target.value)
    const selectedValue = event.target.value;
    setWithin(selectedValue)
  };
  const fetchDistrict=()=>{
    let layerss=[]
    layers.map(function(val, index){
      if(val.query){
        layerss.push({
          name:val.text,
          database:val.database
        })
      }
     })
     setCircle(layerss);
  }
  const fetchData = async (data) => {
    try {
      layers.map(async function(val, index){
        if(val.query && val.database===data && val.fields){
          seturl(val.url)
          if(val.fields){
            setDropdowns(val.fields)
          }
        }
      })
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const getdropdwon=async ()=>{
    const fetches = dropdowns.map(dropdown => fetch(dropdown.url));
    const responses = await Promise.all(fetches);
    const data = await Promise.all(responses.map(response => response.json()));
    const dropdownOptions = dropdowns.map((dropdown, index) => ({
      id: dropdown.id,
      options: data[index].map(item => ({
        value: item.data+','+item.col, 
        label: item.data
      }))
    }));
    console.log(dropdownOptions)
    setmaindata(dropdownOptions)
    dropdownOptions.map((dropdown, index) => (
      setSelectedValues(prevState => ({
        ...prevState,
        [index]: 'All'
      }))
    ))
    setOptions(dropdownOptions);
  }
  useEffect(() => {
    getdropdwon()
  }, [dropdowns]);

  const getCircle=async ()=>{
    try {
      const response = await fetch('http://112.133.197.42/API/circleList.php'); // Replace with your API URL
      const jsonData = await response.json();
      setCircleData(jsonData);
      console.log(jsonData)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
   
  }
  const getVillage=async ()=>{
    try {
      const response = await fetch('http://112.133.197.42/API/villageList.php'); // Replace with your API URL
      const jsonData = await response.json();
      setVillageData(jsonData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
   
  }
  const handleCricle=(event)=>{
    const selectedValue = event.target.value;
    setCircleHandle(selectedValue)
  }
  const handleVillage=(event)=>{
    const selectedValue = event.target.value;
    setvillageHandle(selectedValue)
  }
  const mainSubmit =()=>{
    userLogs()
    const arrData=[]
    let jsonData={}
    maindata.map((dropdown, index) => {
      if(selectedValues[index]==='All'){
        arrData.push({
          name:"",
          value:selectedValues[index]
        })
      }
      else{
        const ff=selectedValues[index].split(',')
        arrData.push({
          name:ff[1],
          value:ff[0]
        })
      }

  })


      jsonData = {
        TableName:database,
        Fields:arrData,
        within:showElements,
        withinData:{
          type: within==='Village'? "villagenam" :"cl_name",
          table:within==='Village' ? "village_boundary" : "circle_boundary",
          condition:within==='Village'?  VillageHandle : circleHandle
        }
       };
    
    console.log(jsonData)
    var fdata = new FormData();
    fdata.append("json", JSON.stringify(jsonData));
    axios({
      method: "post",
      url: url,
      data: fdata,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        if(response.data){
          console.log(response.data)
          dispatch(setAnalyticsVisual({data:response.data, withincol:within,maincol:selectedOption})) 
        }
        
      })
      .catch(function (response) {
    });
    
  }
  useEffect(() => {
    fetchDistrict()
    getCircle()
    getVillage()
  }, []);
  
  const handleDropdownChange = (index, value) => {
    setSelectedValues(prevState => ({
      ...prevState,
      [index]: value
    }));
  };

  return (
    <React.Fragment>
      <Filters>
      <div id="ediit" className={classes.Edit}>
      <div onClick={() => ChangeMap()}> <img src={close} className={classes.Close} /></div>
        <label  className="text-head">Select Formula:</label>
        <select className="dropdown"  onChange={handlerc}>
          <option key={-11} value='Select'>Select</option>
          {/* {circle.map((option, index) => ( 
            <option key={index} value={option.database}>{option.name}</option>
          ))} */}
        </select>
        <label  className="text-head">Select Filters:</label>
        {/* {options.map((dropdown, index) => (
          <select className="dropdown"  key={index}
          value={selectedValues[index] || ''}  onChange={event => handleDropdownChange(index, event.target.value)}
          >
            <option key={-11} value='All'>All</option>
            {dropdown.options.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        ))} */}
        <label  className="text-head">Select Within:</label>
        <label>
          <input
            type="radio"
            name="visibility"
            value="show"
            checked={showElements}
            onChange={handleRadioChange}
          />
          Yes
        </label>

        <label>
          <input
            type="radio"
            name="visibility"
            value="hide"
            checked={!showElements}
            onChange={handleRadioChange}
          />
          No
        </label>
        {showElements &&  <div>
        <select className="dropdown"  onChange={handleWithin}>
          <option key={-11} value='Select'>Select</option>
          <option key={-11} value='Village'>Village</option>
          <option key={-11} value='Circle'>Circle</option>
        </select>
        {
          within==='Circle' ? (<div><label  className="text-head">Select Cricle:</label>
          <select className="dropdown"  onChange={handleCricle}>
            <option key={-11} value='Select'>Select</option>
            {/* {circleData.map(option => (
              <option key={option.id} value={option.cl_name}>{option.cl_name}</option>
            ))} */}
          </select></div>): ''
        }
        </div>}
        <button className="button" onClick={mainSubmit} type="submit">Submit</button>
      
      </div>
      </Filters>
    </React.Fragment>
  );
};

export default Filter;
const Filters = styled.div`

.dropdown {
  width: 100%;
  height: 25px;
  font-family: 'Poppins';
  font-size: 15px;
  border-radius: 10px;
}
.text-head{
  font-family: 'Poppins';
  font-size: 15px;
  padding:10px
}
.dropdown-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label {
  margin-bottom: 10px;
}

.select {
  margin-bottom: 20px;
}

.button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  margin-top:10px;
  border-radius: 10px;
}

`